/**
 * Load Judgment Selling SSOT markdown (host docs/) at build/runtime.
 * Path is outside `tools/game-proto` — vite `server.fs.allow` covers it.
 */
import raw from "../../../../../docs/architecture/Game_Proto_Judgment_Selling_기질.md?raw";
import {
  parseJudgmentSellHelp,
  type JudgmentSellHelpDoc,
} from "./parse-judgment-sell-help";

let cached: JudgmentSellHelpDoc | null = null;

/** Parsed SSOT — throws on first access if markers/sections incomplete. */
export function judgmentSellHelp(): JudgmentSellHelpDoc {
  if (!cached) cached = parseJudgmentSellHelp(raw);
  return cached;
}

/** Raw markdown (tests / diagnostics). */
export function judgmentSellHelpRaw(): string {
  return raw;
}
